export type LanguageKey = "pt" | "es" | "en";

export type ModalTranslations = {
	/** Accessible label for the runtime-owned close button. */
	closeLabel: string;
};

const translations: Record<LanguageKey, ModalTranslations> = {
	pt: {
		closeLabel: "Fechar",
	},
	es: {
		closeLabel: "Cerrar",
	},
	en: {
		closeLabel: "Close",
	},
};

export function getModalTranslations(
	language: string | undefined,
): ModalTranslations {
	const lang = (language?.toLowerCase() || "pt") as LanguageKey;
	return translations[lang] || translations.pt;
}
